import { Stack, styled, Switch, Typography } from "@mui/material";

export const CustomSwitch = styled(Switch)(({ theme }) => ({
  width: 60,
  height: 30,
  padding: 0,
  display: "flex",
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(30px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "#B3D4FF", // bleu foncé
        opacity: 1,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    width: 26,
    height: 26,
    boxShadow: "none",
  },
  "& .MuiSwitch-track": {
    borderRadius: 30 / 2,
    backgroundColor: "#0C2E52", // bleu clair
    opacity: 1,
    transition: theme.transitions.create(["background-color"]),
  },
}));
export const DescriptionPrice = styled(Typography)(({ theme }) => ({
  color: "#8985ad",
  fontFamily: "Inter",
  fontSize: "16.831px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "normal",
  padding: " 1rem 0",
}));
export const StackStyled = styled(Stack)(({ theme }) => ({
  [theme.breakpoints.down(786)]: {
    margin: "2rem 0",
  },
}));
